import React from 'react';

import { primaryColor, unit } from '@zego/theme';

import Spacer from '@zego/components/atoms/Spacer';
import ComparisonTableSection from '@zego/components/ComparisonTableSection';
import SectionDisplay from '@zego/components/SectionDisplay';
import SubItemsSection from '@zego/components/SubItemsSection';

import Annual from '@zego/static/images/graphics/Annual.svg';
import ThirtyDaysPrivateHire from '@zego/static/images/graphics/ThirtyDaysPrivateHire.svg';
import FcIcon from '@zego/static/svgs/fc-icon.svg';
import TpoIcon from '@zego/static/svgs/tpo-icon.svg';

const COMPARISON_TABLE_COPY = {
  desktopTitle: 'What level of cover can I get?',
  mobileTitle: 'What type of cover can I get? ',
  description:
    'You have the choice between two types of Private Hire insurance: Third Party Only and Fully Comprehensive. If you have an accident and damage another vehicle, Third Party Only would cover the repair or replacement of that vehicle, but not yours. Fully Comprehensive would cover both.',
  showDescriptionOnMobile: false,
  tableHeaders: [
    { label: 'Third Party Only', icon: TpoIcon, circular: true },
    { label: 'Fully Comprehensive', icon: FcIcon, circular: true },
  ],
  rowsData: [
    {
      description:
        'Any costs for causing damage to other vehicles or property up to £5m',
      columns: [{ checked: true }, { checked: true }],
    },
    {
      description:
        'Your legal liability for causing death or injury to other people',
      columns: [{ checked: true }, { checked: true }],
    },
    {
      description: 'Public Liability cover up to £5m',
      descriptionNote:
        'This goes towards the cost of any claims made by members of the public for non-motor incidents that occur while you’re working.',
      columns: [{ checked: true }, { checked: true }],
    },
    {
      description:
        'Personal driving, private hire work and food/parcel delivery',
      columns: [{ checked: true }, { checked: true }],
    },
    {
      description: 'Fire damage or the theft of your vehicle',
      columns: [{ checked: false }, { checked: true }],
    },
    {
      description: 'Loss or damage of your vehicle or its spare parts',
      columns: [{ checked: false }, { checked: true }],
    },
    {
      description: 'Windscreen (excess £50)',
      columns: [{ checked: false }, { checked: true }],
    },
    {
      description:
        'Audio, communication and navigation equipment (excess £500)',
      columns: [{ checked: false }, { checked: true }],
    },
  ],
};

const POLICY_OPTIONS = {
  title: 'How long can a policy last?',
  items: [
    {
      title: '30 Days',
      description:
        'Perfect for if you want cover for your work and free time, without any long-term commitment.',
      image: ThirtyDaysPrivateHire,
    },
    {
      title: 'Annual',
      description:
        'Perfect for if you want a long-term policy to cover your work and free time. Financing options available to purchase in instalments.',
      image: Annual,
    },
  ],
};

const PrivateHireComparisonTable = () => (
  <SectionDisplay
    css={{
      backgroundColor: primaryColor(1),
    }}
  >
    <ComparisonTableSection {...COMPARISON_TABLE_COPY} />
    <Spacer height={unit(10)} mobileHeight={unit(9)} />
    <SubItemsSection mobileFontSize={22} {...POLICY_OPTIONS} />
  </SectionDisplay>
);

export default PrivateHireComparisonTable;
